module.exports = __webpack_public_path__ + "img/1560057600.dc6db893.jpg";